import WorkspaceUserManagementNew from "@/routes/workspace/workspaceUserManagementNew.tsx";

export default function ManageUsers() {
  return <WorkspaceUserManagementNew newDesign={true} />;
}
